import React from 'react';

const downloads = [
  {
    title: 'HnB platform overview',
    type: 'Brochure',
    description:
      'A concise public-facing summary of the HnB platform, purpose, and future direction.',
  },
  {
    title: 'Working paper summary',
    type: 'Research',
    description:
      'A readable version of the platform’s business and research rationale for external audiences.',
  },
  {
    title: 'Provider information pack',
    type: 'Onboarding',
    description:
      'A future downloadable guide for salons, barbers, nail studios, tattoo shops, and piercing providers.',
  },
  {
    title: 'AI plans guide',
    type: 'Pricing',
    description:
      'A simple document explaining previews, guest trials, plans, and pay-as-you-go usage.',
  },
  {
    title: 'Showcase deck',
    type: 'Presentation',
    description:
      'A demonstration-oriented file for pilots, stakeholders, and platform walkthroughs.',
  },
  {
    title: 'Brand and media kit',
    type: 'Press',
    description:
      'A downloadable pack for press, partnerships, and presentation consistency.',
  },
];

export default function DownloadsPage() {
  return (
    <main style={{ background: '#f8fafc', color: '#0f172a', minHeight: '100vh' }}>
      <section
        style={{
          padding: '72px 24px 56px',
          background: '#ffffff',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        <div
          style={{
            maxWidth: '1080px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '18px',
          }}
        >
          <p
            style={{
              margin: 0,
              color: '#4f46e5',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
              fontSize: '0.9rem',
            }}
          >
            Downloads
          </p>
          <h1 style={{ margin: 0, fontSize: '3rem', lineHeight: 1.08, maxWidth: '10ch' }}>
            Access public HnB documents and materials
          </h1>
          <p
            style={{
              margin: 0,
              color: '#475569',
              lineHeight: 1.8,
              fontSize: '1.05rem',
              maxWidth: '72ch',
            }}
          >
            Your earlier discussions explicitly called for a public downloads area
            for working papers, brochures, one-pagers, showcase materials, and other
            platform-facing documents.
          </p>
        </div>
      </section>

      <section style={{ padding: '56px 24px 72px' }}>
        <div
          style={{
            maxWidth: '1080px',
            margin: '0 auto',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
            gap: '18px',
          }}
        >
          {downloads.map((item) => (
            <div
              key={item.title}
              style={{
                background: '#ffffff',
                border: '1px solid #e5e7eb',
                borderRadius: '18px',
                padding: '22px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
              }}
            >
              <span
                style={{
                  alignSelf: 'flex-start',
                  padding: '7px 10px',
                  borderRadius: '999px',
                  background: '#eef2ff',
                  color: '#4338ca',
                  fontWeight: 700,
                  fontSize: '0.85rem',
                }}
              >
                {item.type}
              </span>
              <h2 style={{ margin: 0, fontSize: '1.1rem' }}>{item.title}</h2>
              <p style={{ margin: 0, color: '#6b7280', lineHeight: 1.75 }}>
                {item.description}
              </p>
              <button
                type="button"
                style={{
                  marginTop: '6px',
                  alignSelf: 'flex-start',
                  background: '#111827',
                  color: '#ffffff',
                  border: 'none',
                  padding: '11px 14px',
                  borderRadius: '10px',
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                Download
              </button>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}